const identify = (userId: string) => {
  // @ts-expect-error
  window.AF("pba", "setCustomerId", userId);
};

const track = (eventName: string, properties?: Record<string, any>) => {
  // @ts-expect-error
  window.AF("pba", "event", {
    eventType: "EVENT",
    eventName,
    eventValue: properties,
  });
};

export const AppsFlyer = { track, identify };
